import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'ic-activity-monitor-icon',
    templateUrl: './activity-monitor-icon.component.html',
    styleUrls: ['./activity-monitor-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class ActivityMonitorIconComponent {
    // Name of the svg to display.
    readonly iconName = input('');

    // Optional parameters to allow for setting 'inline' styles for icon. If unset, class styles will take precedence.
    readonly color = input<string | null>();
    readonly sizePx = input<number>(0);
}
